const article = {
	slug: "vibe-coding-adhd-dashboard",
	title: "Bridging Empathy Gaps with Vibe Coding",
	date: "April 2025",
	updated: null,
	description: "How an overheard comment about a neurodivergent child led to a focus dashboard prototype built in 37 minutes with an AI agent.",
	keywords: ["vibe coding", "ADHD", "neurodiversity", "rapid prototyping", "AI agents"],
	tldr: "Empathy plus AI agents can lower the barrier to building. A simple focus dashboard for parents of neurodivergent kids went from idea to working prototype in 37 minutes.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, April 2025.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `"My son will never make it to college like his older siblings. That boy is too distracted to focus on things because of his ADHD."

A friend of ours expressed this to me and my wife candidly. It wasn't said with malice, and it came from a place of concern and frustration.

It stayed with my wife. We reflected on the privilege of having a bit of knowledge and empathy around neurodiversity, and how many well-intentioned families and experienced parents may lack these resources.

Since April is the national Neurodiversity awareness month, we wondered: what if we could prototype a simple portal that helps parents build empathy for their neurodivergent children, and for themselves?

## From idea to prototype in 37 minutes

I quickly tapped into my Manus AI Agent portal to cook up a simple prototype with simple ingredients: natural language prompting, patience, and minor stylistic tinkering.

I had this up and running in 37 minutes flat.

This single-page dashboard includes some trackers with an AI chatbot. It also adapts nicely to any phone and tablet screen, reducing dependency on iOS/Android native development frameworks.

It's also important to be cognizant of its current capabilities and limitations. I did have to tweak with some informed understanding of the code from experience.

For example, did you know that these agents almost always use old versions of libraries? Because their LLM knowledge cutoff is usually 6 to 12 months in the past. Also, the 1000 word limit on prompting needs some smart sequential chaining of prompts to save on those precious token credits.

## Vibe coding across organizations

As engineering leaders, we often face the conundrum: prioritize faster time-to-market with an MVP, or aim for a perfectly enterprise-aligned solution before getting anything in front of users?

It is and will be misused a lot by folks who struggle currently with engineering fundamentals, but can be solved by stronger peer reviews.

I feel vibe coding creates much needed momentum to overcome large organizational inertia that can drive buy-in by validating core concepts before major resource investment.

In the past, I and many others might have given up on our next million dollar app ideas because the interfaces we created were not aesthetically sound and would have never made it to market gracefully.

With agents like Manus AI, this barrier has significantly lowered, allowing us to quickly showcase the potential impact of solutions designed with empathy in mind.

The era of keeping methods and approaches secret is behind us. Unblocking others around us creates a 10X impact.

## Gratitude

I will be honest, I had not even heard the term "Neurodiversity" until I was lucky enough to assist as an ally at Renaissance's GAIN (Growing and Including Neurodiversity). It was humbling as well as a stereotype-challenging realization that some of the company's top performers were Neurodiverse.

Thanks to ADAPT at Prudential for helping me gain empathy as an ally and mentor to better understand our coworkers and collaborate effectively.

For those interested in understanding ADHD better as an adult: *"Your Brain's Not Broken"* by Tamara Rosier, Ph.D.`,
};

export default article;
